import { cn } from '@yakit/ui-components';

import type { HTMLProps } from 'react';

export const VDLContainer = ({ ...props }: HTMLProps<HTMLDivElement>) => {
  return <div className={cn('md:px-6', props.className)}>{props.children}</div>;
};
